import {API_URL} from '../config/entrypoint';
import {ajax} from 'rxjs/ajax';

export function addVerificationFileAPI(authToken: string, formData: FormData) {
    return ajax({
        url: `${API_URL}/api/organization_verification_files`,
        method: 'POST',
        body: formData,
        headers: {
            Authorization: 'Bearer ' + authToken,
        },
    });
}
